import Vuetify from '@/plugins/vuetify';

Vuetify.framework.lang.current = (localStorage.getItem('idioma')) ? localStorage.getItem('idioma') : 'pt';

export default {
  filtros: {
    page: 1,
    perPage: 20,
    termo: '',
    order: 'dataChegada',
    direcao: 'DESC',
    referenciaCliente: '',
    modalidadeImportacao: '',
    exportador: '',
    paisOrigem: '',
    descricaoCurta: '',
    quantidade: '',
    modalidadeTransporte: '',
    paisDestino: '',
    valorFOBUnitarioMoeda: '',
    valorFOBUnitarioReal: '',
    valorUnitario: '',
    valorUnitarioNegociado: '',
    moedaInvoice: '',
    valorFOBTotalReal: '',
    dataEmbarque: '',
    dataChegada: '',
    dataRegistroDI: '',
    canalParametrizacao: '',
    dataRegistroCanalParametrizacao: '',
    dataFaturamento: '',
    moedaFreteIntl: '',
    valorFreteInternacionalReal: '',
    valorSeguroInternacionalDolar: '',
    valorSeguroInternacionalReal: '',
    outrasDespesas: '',
    valorCIF: '',
    aliqIIPorcentagem: '',
    aliqIPIPorcentagem: '',
    aliqPISPorcentagem: '',
    aliqCOFINSPorcentagem: '',
    valorII: '',
    valorPIS: '',
    valorCOFINS: '',
  },
  headers: [
    {
      text: 'referenciaCliente',
      value: 'referenciaCliente',
      filterable: true,
      width: '200px',
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'referenciaCliente',
        },
      },
    },
    {
      text: 'referenciaTrust',
      value: 'referenciaTrust',
      filterable: true,
      width: '200px',
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'referenciaTrust',
        },
      },
    },
    {
      text: 'dataAberturaProcesso',
      value: 'dataAberturaProcesso',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '200px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'dataAberturaProcesso',
        },
      },
    },
    {
      text: 'codigoDI',
      value: 'codigoDI',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '130px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'codigoDI',
        },
      },
    },
    {
      text: 'dataRegistroDI',
      value: 'dataRegistroDI',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '130px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'dataRegistroDI',
        },
      },
    },
    {
      text: 'modalidadeImportacao',
      value: 'modalidadeImportacao',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '230px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'modalidadeImportacao',
        },
      },
    },
    {
      text: 'exportador',
      value: 'exportador',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '200px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'exportador',
        },
      },
    },
    {
      text: 'origem',
      value: 'paisOrigem',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '200px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'paisOrigem',
        },
      },
    },
    {
      text: 'produto',
      value: 'descricaoCurta',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '350px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'descricaoCurta',
        },
      },
    },
    {
      text: 'quantidade',
      value: 'quantidade',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '140px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'quantidade',
        },
      },
    },
    {
      text: 'modalidade',
      value: 'modalidadeTransporte',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '200px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'modalidade',
        },
      },
    },
    {
      text: 'destino',
      value: 'paisDestino',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '200px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'paisDestino',
        },
      },
    },
    {
      text: 'valorFOBUnitarioMoeda',
      value: 'valorFOBUnitarioMoeda',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '240px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'valorFOBUnitarioMoeda',
        },
      },
    },
    {
      text: 'valorFOBUnitarioReal',
      value: 'valorFOBUnitarioReal',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '240px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'valorFOBUnitarioReal',
        },
      },
    },
    {
      text: 'valorUnitario',
      value: 'valorUnitario',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '180px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'valorUnitario',
        },
      },
    },
    {
      text: 'valorUnitarioNegociado',
      value: 'valorUnitarioNegociado',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '245px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'valorUnitarioNegociado',
        },
      },
    },
    {
      text: 'moedaInvoice',
      value: 'moedaInvoice',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '200px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'moedaInvoice',
        },
      },
    },
    {
      text: 'valorFOBTotalReal',
      value: 'valorFOBTotalReal',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '200px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'valorFOBTotalReal',
        },
      },
    },
    {
      text: 'dataEmbarque',
      value: 'dataEmbarque',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '200px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'dataEmbarque',
        },
      },
    },
    {
      text: 'dataChegada',
      value: 'dataChegada',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '200px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'dataChegada',
        },
      },
    },
    {
      text: 'canalParametrizacao',
      value: 'canalParametrizacao',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '200px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'canalParametrizacao',
        },
      },
    },
    {
      text: 'dataRegistroCanalParametrizacao',
      value: 'dataRegistroCanalParametrizacao',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '200px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'dataRegistroCanalParametrizacao',
        },
      },
    },
    {
      text: 'dataFaturamento',
      value: 'dataFaturamento',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '200px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'dataFaturamento',
        },
      },
    },
    {
      text: 'moedaFreteIntl',
      value: 'moedaFreteIntl',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '200px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'moedaFreteIntl',
        },
      },
    },
    {
      text: 'valorFreteInternacionalReal',
      value: 'valorFreteInternacionalReal',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '200px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'valorFreteInternacionalReal',
        },
      },
    },
    {
      text: 'valorSeguroInternacionalDolar',
      value: 'valorSeguroInternacionalDolar',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '200px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'valorSeguroInternacionalDolar',
        },
      },
    },
    {
      text: 'valorSeguroInternacionalReal',
      value: 'valorSeguroInternacionalReal',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '200px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'valorSeguroInternacionalReal',
        },
      },
    },
    {
      text: 'outrasDespesas',
      value: 'outrasDespesas',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '200px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'outrasDespesas',
        },
      },
    },
    {
      text: 'valorCIF',
      value: 'valorCIF',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '200px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'valorCIF',
        },
      },
    },
    {
      text: 'aliqIIPorcentagem',
      value: 'aliqIIPorcentagem',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '200px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'aliqIIPorcentagem',
        },
      },
    },
    {
      text: 'aliqIPIPorcentagem',
      value: 'aliqIPIPorcentagem',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '200px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'aliqIPIPorcentagem',
        },
      },
    },
    {
      text: 'aliqPISPorcentagem',
      value: 'aliqPISPorcentagem',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '200px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'aliqPISPorcentagem',
        },
      },
    },
    {
      text: 'aliqCOFINSPorcentagem',
      value: 'aliqCOFINSPorcentagem',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '200px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'aliqCOFINSPorcentagem',
        },
      },
    },
    {
      text: 'valorII',
      value: 'valorII',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '200px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'valorII',
        },
      },
    },
    {
      text: 'valorPIS',
      value: 'valorPIS',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '200px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'valorPIS',
        },
      },
    },
    {
      text: 'valorCOFINS',
      value: 'valorCOFINS',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '200px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'valorCOFINS',
        },
      },
    },
    {
      text: 'siscomex',
      value: 'siscomex',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '200px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'siscomex',
        },
      },
    },
    {
      text: 'valorTotalNFe',
      value: 'valorTotalNFe',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '200px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'valorTotalNFe',
        },
      },
    },
    {
      text: 'valorArmazenagem',
      value: 'valorArmazenagem',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '200px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'valorArmazenagem',
        },
      },
    },
    {
      text: 'freteNacional',
      value: 'freteNacional',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '200px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'freteNacional',
        },
      },
    },
    {
      text: 'totalDespesas',
      value: 'totalDespesas',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '200px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'totalDespesas',
        },
      },
    },
    {
      text: 'valorDescComercial',
      value: 'valorDescComercial',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '240px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'valorDescComercial',
        },
      },
    },
    {
      text: 'codigoDocFiscalSaida',
      value: 'codigoDocFiscalSaida',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '300px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'codigoDocFiscalSaida',
        },
      },
    },
    {
      text: 'baseCalculoIPI',
      value: 'baseCalculoIPI',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '250px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'baseCalculoIPI',
        },
      },
    },
    {
      text: 'baseCalculoImpostoImportacao',
      value: 'baseCalculoImpostoImportacao',
      filterable: true,
      filterComponent: 'TextFilter',
      width: '230px',
      isDataTable: true,
      filterParams: {
        module: 'despesasImportacao',
        fetch: 'fetchDespesasImportacao',
        colDef: {
          field: 'baseCalculoImpostoImportacao',
        },
      },
    },
  ],
  listaDespesasImportacao: [],
};
